module.exports = __webpack_public_path__ + "static/EWY_Kirsty_social-cover-5efc21d7e7520148ca2622e1c0799a46.png";